import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';

import { StorageService } from '@core/_services/storage.service';
import { Logout } from '@core/auth';
import { AppState } from '@core/reducers';

import { BrowserCookieStorage } from '@core/_services/browser-cookie.storage';

@Component({
  selector: 'kt-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss'],
})
export class LogoutComponent implements OnInit, OnDestroy {
  previousUrl = '';
  private unsubscribe: Subject<any> = new Subject<any>();

  constructor(
    private store: Store<AppState>,
    private route: ActivatedRoute,
    private router: Router,
    private cookieStorage: BrowserCookieStorage,
    private storage: StorageService,
  ) {}

  ngOnInit() {
    this.route.queryParamMap.pipe(takeUntil(this.unsubscribe)).subscribe((queryParams) => {
      if (queryParams.get('loggedAsUser')) {
        const authToken = this.storage.get('adminToken', false);

        if (authToken) {
          this.cookieStorage.setItem('Authorization', authToken, { domain: document.location.hostname });

          this.storage.remove('adminToken');
        }

        this.router.navigateByUrl(queryParams.get('redirectTo')).then(() => document.location.reload());
      } else {
        this.storage.remove('adminToken');
        this.store.dispatch(new Logout({ redirect: true }));
      }
    });
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
